<template>
    <div class="flex justify-content-center mb-5">
        <div class="flex align-items-center gap-5 p-3 bg-white">
            <div class="flex-order-2 md:order-1">
                <img src="/i/pages/tariff/banner-x2.webp" alt="" />
            </div>
            <div class="flex flex-column gap-3 flex-order-1 md:flex-order-2 w-min sm:w-auto">
                <p class="text-2xl font-bold m-0 p-0">
                    <span class="text-gray-900">Оплати с партнерского баланса </span>
                    <span class="text-primary"> со скидкой 50%</span>
                </p>
                <span class="text-primary block md:hidden cursor-pointer" @click="onClickMore()">Подробнее</span>
            </div>
            <div class="hidden md:flex flex-order-3">
                <Button outlined label="Подробнее" @click="onClickMore()" />
            </div>
        </div>
    </div>
</template>

<script>
import Button from "primevue/button";

export default {
    name: "TariffPagePartnerBanner",
    components: {
        Button,
    },
    methods: {
        onClickMore() {
            window.open('//help.keys.so/faq#hfaq-post-2592');
        }
    }
}
</script>

<style scoped>
img {
    max-height: 100px;
    margin-left: -80px;
    margin-bottom: -30px;
    margin-top: -30px;
}
@media (max-width: 1300px) {
    img {
        margin-left: 0;
    }
}
</style>
